export default __webpack_public_path__ + "static/media/404.5466bc06.svg";